<template>
    <div class="product-item">
        <a :href="product.url || url" :title="product.title">
            <div class="product-item__image">
                <img v-if="product.images.length" :data-src="product.images[0] | imageSize('500x')" :alt="product.title" class="lazyload"/>
                <slot v-else name="placeholder-image"></slot>
                <span v-if="isOutOfStock" class="product-badge product-badge--best-seller">{{ translations.out_of_stock }}</span>

            </div>
            <div class="product-item__description">
                <span class="product-item__brand">{{ product.vendor }}</span>

                <div class="product-item__name product-name">{{ product.title }}</div>
                
                <s v-if="isSale" class="price price--old">{{ product.compare_at_price | currencyFromCents }}</s>
                <span class="price" :class="{ 'price--sale': isSale }">{{ product.price  | currencyFromCents }}</span>
                <div>
                  <span class="product-item--discount" v-if="isSale">{{ Math.round((product.compare_at_price - product.price) / (product.compare_at_price) * 100 )}} % OFF</span>
                </div>
            </div>
        </a>

        <!-- Desktop -->
        <div v-if="moreColor && moreColor.length > 0" class="product-item__colors desktop d-none d-md-flex">
            <span class="color--title">
                {{moreColor.length }} {{ translations.colour}}
            </span>
            <div class="color--selection">
                <a v-for="color in moreColor" :key="color.id" :href="'/products/'+ color.split('|')[2]" :title="color.split('|')[2] | titleCase ">
                    <span :class="(product.handle == color.split('|')[2]) ? 'active' : '' " :style="{backgroundColor: color.split('|')[1] }">
                        {{ color.split('|')[2] | titleCase }}
                    </span>
                </a>
            </div>
        </div>
        <!-- Mobile -->
        <div v-if="moreColor && moreColor.length > 0" class="product-item__colors mobile d-md-none">
            <a :href="urlWithinCollection || url" class="color--title">
                + {{moreColor.length }} {{ translations.colour}}
            </a>
        </div>
    </div>
</template>

<script>
export default {

    props: {
        product: {
        type: Object
        },
        translations: {
        type: Object
        },

    },

    data() {
        return {
            url: null,
            moreColor: [],
            showMoreColors: false
        }
    },

    mounted(){
        this.moreColor = this.product.tags.filter(tag => {
            return tag.includes('moreColour|');
        });
    }, 

    computed: {
        isSale() {
            return this.product.compare_at_price && this.product.price < this.product.compare_at_price;
        },
        isOutOfStock() {
            if(!this.product.available && this.product.type != "Gift Card" ) {
                return true;
            }
        },
    },

    created() {
        if (!this.product.url) {
            this.url = `/products/${this.product.handle}`;
        }
    },

    methods: {
        toggleColor(){
            this.showMoreColors = !this.showMoreColors;
        }
    }
}
</script>